import {setDefaultTrustPolicy} from "./utils/util";

setDefaultTrustPolicy();
import './sentryJS/sentryJS-config';

import ('./bootstrap');
